var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{class:_vm.hasTouch,attrs:{"id":"main","role":"main"}},[_c('transition',{attrs:{"name":"square","mode":"out-in"}},[_c('nuxt')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }